import React from 'react';

export default function ({ onClick, children }) {
    return (
        <button className="link-button" onClick={onClick}>
            {children}
        </button>
    )
}
